import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './field.module.scss';


export function Field ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={ cn(styles.root, className) }
            { ...props }
        />
    );
}
